export enum PreRegistrationUseType {
  academic = 'academic',
  personal = 'personal',
}

export enum PreRegistrationAcademicStatus {
  highSchool = 'highSchool',
  undergraduate = 'undergraduate',
  masters = 'masters',
  doctoral = 'doctoral',
  faculty = 'faculty',
}

export const phoneTypeItems = [
  {
    label: 'Mobile',
    value: 'mobile',
  },
  {
    label: 'Home',
    value: 'home',
  },
];

export const ageTypeItems = [
  {
    label: '18+',
    value: '18+',
  },
  {
    label: '16-17',
    value: '16-17',
  },
];

export const useTypeItems = [
  {
    label: 'Academic',
    value: PreRegistrationUseType.academic,
  },
  {
    label: 'Personal/job related',
    value: PreRegistrationUseType.personal,
  },
];

export const academicStatusItems = [
  {
    label: 'High school',
    value: PreRegistrationAcademicStatus.highSchool,
  },
  {
    label: 'Undergraduate',
    value: PreRegistrationAcademicStatus.undergraduate,
  },
  {
    label: 'Masters',
    value: PreRegistrationAcademicStatus.masters,
  },
  {
    label: 'Doctoral',
    value: PreRegistrationAcademicStatus.doctoral,
  },
  {
    label: 'Faculty',
    value: PreRegistrationAcademicStatus.faculty,
  },
];

export const dropdownOptionScheme = {
  label: '',
  value: '',
};

export const academicInstitutionItems = [
  {
    label: 'American University',
    value: 'americanUniversity',
  },
  {
    label: 'Bowie State University',
    value: 'bowieStateUniversity',
  },
  {
    label: 'Catholic University',
    value: 'catholicUniversity',
  },
  {
    label: 'Gallaudet University',
    value: 'gallaudetUniversity',
  },
  {
    label: 'George Mason University',
    value: 'georgeMasonUniversity',
  },
  {
    label: 'George Washington University',
    value: 'georgeWashingtonUniversity',
  },
  {
    label: 'Georgetown University',
    value: 'georgetownUniversity',
  },
  {
    label: 'Howard University',
    value: 'howardUniversity',
  },
  {
    label: 'John Hopkins University',
    value: 'johnHopkinsUniversity',
  },
  {
    label: 'Montgomery Community College',
    value: 'montgomeryCommunityColl',
  },
  {
    label: 'Northern Virginia Community College',
    value: 'northernVirginiaCommunityColl',
  },
  {
    label: 'Price George Community College',
    value: 'princeGeorgeCommunityColl',
  },
  {
    label: "St. John's College",
    value: 'stJohnsCollege',
  },
  {
    label: 'Towson University',
    value: 'towsonUniversity',
  },
  {
    label: 'Trinity College',
    value: 'trinityCollege',
  },
  {
    label: 'Udc',
    value: 'udc',
  },
  {
    label: 'University of Maryland',
    value: 'universityOfMaryland',
  },
  {
    label: 'University of Virginia',
    value: 'universityOfVirginia',
  },
  {
    label: 'Other',
    value: 'other',
  },
];
